import { createSlice } from "@reduxjs/toolkit";
import { logout } from "../login/loginSlice";
import { resolvePasswordPolicy } from "./thunks/accountThunks";
import {
  disableTwoFactor,
  enableTwoFactor,
  resolveTwoFactor,
} from "./thunks/twoFactorThunks";
import { initialState } from "./state/securityState";

export const securitySlice = createSlice({
  name: "security",
  initialState,
  reducers: {
    clearPasswordPolicy: (state) => ({
      ...state,
      passwordPolicy: null,
    }),
    clearTwoFactorSetupInfo: (state) => ({
      ...state,
      twoFactorSetupInfo: null,
    }),
    clearTwoFactor: (state) => ({
      ...state,
      twoFactorSetupInfo: null,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(resolvePasswordPolicy.fulfilled, (state, action) => ({
      ...state,
      passwordPolicy: action.payload,
    }));

    builder.addCase(resolveTwoFactor.pending, (state) => ({
      ...state,
      twoFactorStatus: "loading",
    }));
    builder.addCase(resolveTwoFactor.fulfilled, (state, action) => ({
      ...state,
      twoFactorStatus: "idle",
      twoFactorEnabled: action.payload.alreadyEnabled === true,
      twoFactorSetupInfo: action.payload,
    }));
    builder.addCase(resolveTwoFactor.rejected, (state) => ({
      ...state,
      twoFactorStatus: "failed",
    }));

    builder.addCase(enableTwoFactor.pending, (state) => ({
      ...state,
      twoFactorStatus: "enabling",
    }));
    builder.addCase(enableTwoFactor.fulfilled, (state) => ({
      ...state,
      twoFactorStatus: "idle",
      twoFactorEnabled: true,
    }));
    builder.addCase(enableTwoFactor.rejected, (state) => ({
      ...state,
      twoFactorStatus: "idle",
    }));

    builder.addCase(disableTwoFactor.pending, (state) => ({
      ...state,
      twoFactorStatus: "disabling",
    }));
    builder.addCase(disableTwoFactor.fulfilled, (state) => ({
      ...state,
      twoFactorStatus: "idle",
      twoFactorEnabled: false,
      twoFactorSetupInfo: null,
    }));
    builder.addCase(disableTwoFactor.rejected, (state) => ({
      ...state,
      twoFactorStatus: "idle",
    }));

    builder.addCase(logout.fulfilled, () => ({
      ...initialState,
    }));
  },
});

export const {
  clearPasswordPolicy,
  clearTwoFactorSetupInfo,
  clearTwoFactor,
} = securitySlice.actions;

export default securitySlice.reducer;

export * from "./state/securityState";
export * from "./thunks/types";
export * from "./thunks/accountThunks";
export * from "./thunks/twoFactorThunks";
